<template>
  <ul class="form-item-list">
    <li><h3><b>[태아의 경우]</b> 임신과정 또는 산전검사에서 아래와 같은 태아 이상 가능성이 발견되었거나 진단을 받은 적이 있습니까?</h3></li>
    <li>
      <p>1. 선천성 기형</p>
      <p>2. 선천성 장애</p>
      <p>3. 자궁내발육부전</p>
      <p>4. 큰몸증</p>
      <p>5. 신경학적결손</p>
      <p>6. 염색체이상</p>
      <p>7. 양수과소증</p>
      <p>8. 양수과다증</p>
      <p>9. 태아수종</p>
      <p>10. 용혈성질환</p>
      <p>11. 태아감염</p>
      <p>12. 인공수정</p>
      <p>13. 다태아임신</p>
      <p>14. 과숙임신</p>
      <p>15. 전치태반</p>
      <p>16. 태반조기박리</p>
      <p>17. 자궁경관무력증</p>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
  </ul>
</template>

<script>
import { Checkbox } from 'element-ui';

export default {
  name: 'Fetus',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
    }
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
}
</style>